<template>
  <div class="reviewPage aboutView" style="padding-top:0px;padding-bottom:0px">
    <div>
      <mavon-editor
        :style="`min-height:${minHeight}px`"
        :subfield="false"
        defaultOpen="preview"
        :toolbarsFlag="false"
        :toolbars="markdownOption"
        :boxShadow="false"
        @change="change"
        v-model="articleMsg.articleContent"
      />
    </div>
    <!-- 首页按钮 -->
    <div class="indexDiv" @click="gotoIndex">
      <div style="margin-top:10px;"><img src="../../assets/images/mp-home.png" style="width:40px;height:40px;" /></div>
      <div>返回首页</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      markdownOption: {},
      articleMsg: {
        articleContent:
          "## <center>MPai公测时间延长公告</center>\n\n### 尊敬的用户您好:  \n#### MPai数据科学平台公测截止日期由8月25日延长至8月31日。<br/><br/><br/><br/><br/><br/>广州万灵数据科技有限公司\n\n2020年8月25日"
      },
      html: ""
    };
  },
  mounted() {
    this.getHelpDocsApi();
  },
  watch: {
    
  },
  computed: {
    minHeight: {
      get() {
        return this.$store.state.height;
      },
      set(height) {
        this.$store.dispatch("commitHeight", height);
      }
    }
  },
  methods: {
    //首页跳转
    gotoIndex(){
      this.$router.push({
        path: "/",
        // query: {
        //   analysisId: this.analysis_id,
        //   projectId: this.project_id,
        //   algorId: this.algor_id
        // }
      });
    },
    change(value, render) {
      // render 为 markdown 解析后的结果[html]
      this.html = render;
    },
    getHelpDocsApi(articleId) {
      // {currentPageNum:1,queryParams:{articleType:2}}
      var that = this;
      this.$axios
        .getHelpDocs()
        .then(res => {
          console.log("获取帮助文档",res)
          that.articleMsg = res.data.data;
        })
        .catch(() => {
          // this.$router.replace("/notice");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../public/static/style/page.less";
.indexDiv{
  width: 100px;
  height: 100px;
  z-index: 99999;
  border-radius: 50%;
  position: fixed;
  background-color: #fff;
  text-align: center;
  right: 25px;
  bottom: 100px;
  box-shadow: 0 1px 3px rgba(26, 26, 26, 0.1);
}
</style>
